import LongText from './longText.js';
export default LongText;
